<div class="content-style-class">
  <div fxLayout="row" fxLayoutAlign="space-between center">
    <div fxLayout="column">
      <h2 class="title-style">{{ dataService.res('Ubt-TreeList-Reports') }}</h2>
    </div>
    <abc-button 
      class="button"
      [text]="dataService.res('Generate-Report')"
      (onClick)="openGenerateReportPopup()"
    >
    </abc-button>
  </div>
  <abc-popup
  #openGenerateReport
  [height]="'auto'"
  [width]="'25%'"
  fxLayoutAlign="center center"
  [title]="dataService.res('Title-Popup')"
>
  <div
    class="dx-card popup-card-paddings card-radius"
    fxLayout="column"
    fxLayoutGap="20px"
  >
    <dx-date-box #dateBox 
    class="date-box-style"
    [value]="selectedDate" 
    type="date" 
    [label]="dataService.res('Select-date')"
    [labelMode]="'floating'"
    displayFormat="dd/MM/yyyy"  
    [max]="maxDate"
    ></dx-date-box>

    <dxi-item itemType="group" fxLayout="row" fxLayoutAlign="end end" fxLayoutGap="20px">
      <abc-button
        class="submit-button"
        [text]="dataService.res('Generate-Report')"
        (onClick)="generateReport(dateBox.value)"
      >
      </abc-button>
      <abc-button class="cancel-button" [text]="dataService.res('Ubt-Company-Button-Cancel')" (onClick)="closePopup()">
      </abc-button>
    </dxi-item>
  </div>
</abc-popup>
  <div class="content-block">
    <div class="dx-card responsive-paddings card-radius">
      <dx-tabs class="tableContainer" [dataSource]="tabs" [selectedIndex]="0" (onItemClick)="openTab($event)"></dx-tabs>
      <abc-grid
        #allReportsGrid
        id="gridContainer"
        [showBorders]="true"
        class="grid-group-by-Style custome-export-style icons-report-style reports-grid"
        [dataSource]="allReports"
        [height]="'93%'"
        [noDataText]="noDataText"
        (onCellPrepared)="cellPrepared($event)"
        (onExporting)="onExporting($event)"
      >
        <dxo-export [enabled]="true" [formats]="['pdf', 'xlsx']" [allowExportSelectedData]="false"></dxo-export>
        <dxi-column
          caption="{{ dataService.res('Ubt-MeasureDetail-Progress') }}"
          dataField="progress"
          visibleIndex="0"
          width="20%"
          dataType="string"
          alignment="left"
          [cellTemplate]="cellTemplates[0]"
        >
        </dxi-column>

        <dxi-column
          caption="{{ dataService.res('Ubt-MeasureDetail-Next-Steps') }}"
          dataField="nextSteps"
          visibleIndex="1"
          width="20%"
          dataType="string"
          alignment="left"
          [cellTemplate]="cellTemplates[1]"
        >
        </dxi-column>

        <dxi-column
          caption="{{ dataService.res('Ubt-TreeList-Decision') }}"
          dataField="decision"
          visibleIndex="2"
          width="20%"
          dataType="string"
          alignment="left"
          [cellTemplate]="cellTemplates[2]"
        >
        </dxi-column>

        <dxi-column
          caption="{{ dataService.res('Ubt-MeasureDetail-Opportunities') }}"
          dataField="opportunities"
          visibleIndex="4"
          width="20%"
          dataType="string"
          alignment="left"
          [visible]="false"
        >
        </dxi-column>
        <dxi-column
          caption="{{ dataService.res('Ubt-MeasureDetail-Risks-and-Chances') }}"
          dataField="riskAndChance"
          visibleIndex="3"
          width="20%"
          dataType="string"
          alignment="left"
          [cellTemplate]="cellTemplates[3]"
        >
        </dxi-column>

        <dxi-column
          caption="{{ dataService.res('Ubt-MeasureTask-SubProject') }}"
          dataField="subProject"
          width="auto"
          groupIndex="0"
          dataType="string"
          alignment="center"
        >
        </dxi-column>
        <dxi-column
          caption="{{ dataService.res('Ubt-CreateMeasureTask-Measure') }}"
          dataField="measure"
          width="auto"
          groupIndex="1"
          dataType="string"
          alignment="center"
        >
        </dxi-column>
        <dxi-column
          caption="Status"
          dataField="status"
          visibleIndex="5"
          width="10%"
          dataType="string"
          [allowGrouping]="false"
          cellTemplate="diffCellTemplate"
          alignment="left"
        >
        </dxi-column>
        <dxi-column type="buttons" [width]="'70px'" visibleIndex="10">
          <dxi-button
            hint="{{ dataService.res('Ubt-Go-To-Measure') }}"
            icon="edit"
            [visible]="true"
            [onClick]="openMeasureDetail"
          >
          </dxi-button>
        </dxi-column>
        <div *ngFor="let cellTemplateValue of cellTemplates">
          <div *dxTemplate="let cellTemplate of cellTemplateValue" class="status-align">
            <div [innerHTML]="appService.sanitizeContent(cellTemplate.value)"></div>
          </div>
        </div>
        <div
          *dxTemplate="let statut of 'diffCellTemplate'"
          class="status-align"
          [class]="(statut | gridCellData).state === true ? 'inc' : 'dec'"
        >
          <div sclass=" status-bold" class="current-value">{{ (statut | gridCellData).date | date: 'dd.MM.yyyy' }}</div>
          <div class="diff">{{ (statut | gridCellData).progress }}</div>
          <div class="status-grouped-by">
            {{ (statut | gridCellData).maturity }}
          </div>
        </div>

        <dxo-pager [visible]="false"> </dxo-pager>
        <dxo-column-chooser [search]="{ enabled: true }" [enabled]="true"> </dxo-column-chooser>
        <dxo-header-filter #dxHeaderFilter [visible]="true"></dxo-header-filter>
        <dxo-filter-row [visible]="true"></dxo-filter-row>
        <dxo-group-panel [visible]="true"></dxo-group-panel>
        <dxo-scrolling mode="virtual"></dxo-scrolling>
        <dxo-filter-panel [visible]="true"></dxo-filter-panel>
        <dxo-grouping [expandMode]="'rowClick'"></dxo-grouping>
        <dxo-search-panel [visible]="true"> </dxo-search-panel>
        <dxo-export [enabled]="true" [allowExportSelectedData]="false"></dxo-export>
        <dxo-summary>
          <dxi-group-item column="subProject" summaryType="count"> </dxi-group-item>
        </dxo-summary>
      </abc-grid>
    </div>
  </div>
</div>

